module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei7.svg";